import { EnvironmentType } from "../types/environment.type";
import { IEnvironment } from "./environment.interface";
import { getEnvironmentVariable } from './environment.loader';

export const Environment: IEnvironment = {
  ENVIRONMENT_TYPE: EnvironmentType.Base,
  API_URL: getEnvironmentVariable('api-url', 'http://develop.engenharia-vd.totvs.io:15200/'),
  HOST_APIV2: getEnvironmentVariable('HOST_APIV2', 'http://develop.engenharia-vd.totvs.io:15200/'),
  HOST_TOMAS: getEnvironmentVariable('HOST_TOMAS', 'https://us-central1-totvs-engenharia-varejo.cloudfunctions.net/tomas-log-dev'),
  HOST_MODAWEB: getEnvironmentVariable('HOST_MODAWEB', 'http://develop.engenharia-vd.totvs.io:15001/'),
}